export const pageview = (url: string): void => {
  window?.dataLayer?.push({
    event: `pageview`,
    page: url,
  });
};

export const fireCustomEvent = (eventName: string, url: string): void => {
  window?.dataLayer?.push({
    event: eventName,
    page: url,
  });
};
